module.exports = __webpack_public_path__ + "9d6b549365c63c43b8b39d175d7afa94.pdf";